/** =========================================================
 * Module: items-filter-alert.directive.js
 * Data items filters alert
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.components')
    .directive('itemsFilterAlert', itemsFilterAlert);

  itemsFilterAlert.$inject = [];

  function itemsFilterAlert() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/views/components/items-filter-alert.html',
      link: link,
      scope: {
        config: '='
      }
    };

    return directive;

    function link($scope) {
      if ($scope.config && $scope.config.model && $scope.config.getData && $scope.config.getDataParams && $scope.config.filters) {
        $scope.getContent = function () {
          return $scope.config.filters.map(function (filter) { return filter.name; }).join(' / ');
        };

        $scope.clearFilters = function () {
          try {
            $scope.config.filters = [];
            $scope.config.getData();
          } catch (error) {
            Raven.captureException(error);
          }
        };
      }
    }
  }
})();
